module.exports = __webpack_public_path__ + "img/00a7a88.jpg";